import { AppState, type AppStateData } from '../../core/AppState';

export class AppHeader {
  private container: HTMLElement;
  private state: AppState;

  constructor(container: HTMLElement, state: AppState) {
    this.container = container;
    this.state = state;
    this.render();
    this.state.subscribe((data) => this.update(data));
  }

  private render() {
    this.container.innerHTML = `
        <div class="header-left" style="display:flex; align-items:center; gap:20px;">
            <h1 style="margin:0; font-size:1.1rem; font-weight:600;">Visual <span style="color:var(--accent)">Glitch Studio</span></h1>
            <div class="header-controls" style="display:flex; gap:10px;">
                <button id="undoBtn" class="icon-btn" disabled>↶ Undo</button>
                <button id="redoBtn" class="icon-btn" disabled>↷ Redo</button>
            </div>
        </div>
        <button id="downloadBtn" class="primary" disabled>↓ Save</button>
    `;
    this.container.className = 'pane-header'; // Re-use existing style class if possible, or inline styles
    // Inline styles were used in PreviewPane, let's keep them or rely on CSS.
    // The previous implementation used heavy inline styles. I'll copy them to ensure parity.
    this.container.style.backgroundColor = 'var(--panel-bg)';
    this.container.style.padding = '0.8rem 1.5rem';
    this.container.style.borderBottom = '1px solid var(--border)';
    this.container.style.display = 'flex';
    this.container.style.justifyContent = 'space-between';
    this.container.style.alignItems = 'center';
    this.container.style.flexShrink = '0';

    const undoBtn = this.container.querySelector('#undoBtn') as HTMLButtonElement;
    const redoBtn = this.container.querySelector('#redoBtn') as HTMLButtonElement;
    const downloadBtn = this.container.querySelector('#downloadBtn') as HTMLButtonElement;

    undoBtn.onclick = () => this.state.undo();
    redoBtn.onclick = () => this.state.redo();
    downloadBtn.onclick = () => this.download();
  }

  private update(data: AppStateData) {
    const undoBtn = this.container.querySelector('#undoBtn') as HTMLButtonElement;
    const redoBtn = this.container.querySelector('#redoBtn') as HTMLButtonElement;
    const downloadBtn = this.container.querySelector('#downloadBtn') as HTMLButtonElement;

    if (undoBtn) undoBtn.disabled = !this.state.canUndo();
    if (redoBtn) redoBtn.disabled = !this.state.canRedo();
    if (downloadBtn) downloadBtn.disabled = !data.buffer;
  }

  private download() {
    const data = this.state.current;
    if (!data.buffer) return;

    const mimeType = this.getMimeType(data.filename);
    const blob = new Blob([data.buffer as any], { type: mimeType });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `glitched_${data.filename || 'image.jpg'}`;
    a.click();
  }

  private getMimeType(filename: string | null): string {
    if (filename && filename.toLowerCase().endsWith('.webp')) return 'image/webp';
    if (filename && filename.toLowerCase().endsWith('.png')) return 'image/png';
    if (filename && filename.toLowerCase().endsWith('.gif')) return 'image/gif';
    return 'image/jpeg';
  }
}
